import { render } from "./PayboxGateway.vue?vue&type=template&id=37a53431"
import script from "./PayboxGateway.vue?vue&type=script&lang=js"
export * from "./PayboxGateway.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__